import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

    paramConfigOpened = false;
    fileStorageOpened = false;

    constructor() { }

    ngOnInit(): void {
    }

    toggleParamConfig() {
        if(this.paramConfigOpened) {
            this.paramConfigOpened = false;
        }else {
            this.fileStorageOpened = false;
            this.paramConfigOpened = true;
        }
    }

    toggleFileStorage() {
        if(this.fileStorageOpened) {
            this.fileStorageOpened = false;
        }else {
            this.paramConfigOpened = false;
            this.fileStorageOpened = true;
        }
    }
}
